import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { CREATE_NOISE_WAVE, CREATE_WAVE } from '../analytics.constants';
import { NoiseWaveEventType, WaveEventType } from '../types/analytics.types';

export const trackCreateWave =
  (
    name: typeof CREATE_WAVE | typeof CREATE_NOISE_WAVE,
    wave: WaveEventType | NoiseWaveEventType,
    analyticsEventTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    const traits =
      name === CREATE_WAVE
        ? {
            name,
            properties: {
              ecg_id: ecgId,
              view,
              wave: wave as WaveEventType,
              user_id: userId,
            },
          }
        : {
            name,
            properties: {
              ecg_id: ecgId,
              view,
              wave: wave as NoiseWaveEventType,
              user_id: userId,
            },
          };

    analyticsEventTrack(traits);
  };
